import { takeLatest } from 'redux-saga/effects';

import { GET_INVESTOR_RELATIONS } from './investorActions';
import { fetchInvestorRelationsSaga } from './investorSaga';

export function* investorRelationsWatchers() {
  yield takeLatest(GET_INVESTOR_RELATIONS, fetchInvestorRelationsSaga);
}
